import { CardHeader, Text } from "@dxp-feed/ui";

const CardHead = ({ title }: { title: string | null }) => {
  return (
    <CardHeader className="border-none">
      <Text as="span" className="text-base font-bold whitespace-normal">
        {title}
      </Text>
    </CardHeader>
  );
};
export default CardHead;